import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ items, speed = 22 }) {
  const words = items || [
    "Conceptualisation",
    "Composition",
    "Craft",
    "Commissioning",
    "Curation",
    "Continuity",
  ];
  return (
    <section className="bg-ink text-bone py-6 md:py-8 border-y border-ink/10 overflow-hidden" data-testid="editorial-marquee">
      <Marquee gradient={false} speed={speed} pauseOnHover>
        {words.map((w, i) => (
          <span key={i} className="flex items-center pr-10 md:pr-16 shrink-0">
            <span className="editorial-serif text-2xl md:text-4xl leading-[1.25] pb-1 text-bone">{w}</span>
            <span className="mx-6 md:mx-10 text-clay text-xl md:text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
